import React from 'react';
import { Box, Grid, Typography, Paper } from '@mui/material';
import { styled } from '@mui/system';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as Analytic } from '../../Assets/AlertIcon/Analytic.svg';
import { notify } from '../functions/react-toastify.function';
import { logout } from '../functions/log_out.function';
import { useBackdrop } from './backDrop_context.component';
import LogoutIcon from '@mui/icons-material/Logout';
import { SmallPopupIcons } from '../../enums/small_popup_icons';
import { NavigationIcons } from '../../enums/general.names.enum';
import kmzNetworkIcon from '../../Assets/SideNavIcons/kmzNetwork.svg';
const IconBox = styled(Box)(({ theme }) => ({
  width: 48,
  height: 48,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '6px',
  marginBottom: theme.spacing(0.5),
  transition: 'all 0.2s ease-in-out',
  cursor: 'pointer',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
    borderColor: '#BD1D23',
    backgroundColor: 'rgba(189, 29, 35, 0.05)',
  },
}));

const Icon = ({ icon }) => <IconBox dangerouslySetInnerHTML={{ __html: icon }} />;

const StyledGridItem = styled(Grid)(({ theme }) => ({
  transition: 'all 0.2s ease-in-out',
  '&:hover': {
    transform: 'scale(1.05)',
  },
}));

export const SmallPopUpAdmin = ({ handleTabSelection }) => {
  const navigate = useNavigate();
  const { showBackdrop, hideBackdrop } = useBackdrop();
  const permissionsJSON = localStorage.getItem('permissions');
  let permissions = [];
  try {
    permissions = JSON.parse(permissionsJSON) || [];
  } catch (error) {
    console.error('Failed to parse permissions:', error);
  }
  const handleLogout = async () => {
    showBackdrop();
    try {
      const result = await logout();
      navigate('/');
      notify('succes', result.message);
      hideBackdrop();
    } catch (error) {
      notify('error', error.message);
      navigate('/');
      hideBackdrop();
    }
  };
  const permissionNames = Array.isArray(permissions)
    ? permissions.map((permission) => permission.name)
    : [];
  return (
    <>
      <Box sx={{ maxWidth: 320, width: '240px', margin: 'auto' }}>
        {permissionNames.includes('Network Insight') && (
          <>
            <Typography
              variant="h6"
              gutterBottom
              fontSize={'11px'}
              fontWeight={600}
              color="rgba(0, 0, 0, 0.5)"
              sx={{ borderBottom: '1px solid #E4E4E7' }}
            >
              Network Insights
            </Typography>

            <Grid container spacing={1} paddingTop={'6px'}>
              <StyledGridItem item xs={3}>
                <Icon icon={SmallPopupIcons.analytics} />
                <Typography align="center" fontSize={'10px'} fontWeight={600}>
                  Analytics
                </Typography>
              </StyledGridItem>
              <StyledGridItem item xs={3}>
                <Icon icon={SmallPopupIcons.bi} />
                <Typography align="center" fontSize={'10px'} fontWeight={600}>
                  BI
                </Typography>
              </StyledGridItem>
            </Grid>
          </>
        )}

        <Typography
          variant="h6"
          gutterBottom
          sx={{ mt: 1.5, borderBottom: '1px solid #E4E4E7' }}
          fontSize={'11px'}
          fontWeight={600}
          color="rgba(0, 0, 0, 0.5)"
        >
          Administration
        </Typography>
        {/* {(permissionNames.includes('User Management') ||
          permissionNames.includes('Partner Network')) && (
          <Grid container spacing={1} paddingTop={'6px'}>
            {permissionNames.includes('User Management') && (
              <StyledGridItem
                item
                xs={6}
                sx={{ cursor: 'pointer' }}
                onClick={() => navigate('/userManagement')}
              >
                <Icon icon={SmallPopupIcons.management} />
                <Typography align="center" fontSize={'10px'} fontWeight={600}>
                  Access Control
                </Typography>
              </StyledGridItem>
            )}
            {permissionNames.includes('Partner Network') && (
              <StyledGridItem
                item
                xs={6}
                sx={{ cursor: 'pointer' }}
                onClick={() => {
                  console.log('Partner Network clicked from popup');
                  handleTabSelection('partner_network');
                  // Force left bar to update by dispatching a custom event
                                  window.dispatchEvent(
                  new CustomEvent('tabSelectionChanged', {
                    detail: { tab: 'partner_network', iconIndex: NavigationIcons.PARTNER_NETWORK },
                  })
                );
                }}
              >
                <Icon icon={SmallPopupIcons.otn} />
                <Typography
                  align="center"
                  color="rgba(0, 0, 0, 1)"
                  fontSize={'10px'}
                  fontWeight={600}
                >
                  Partner Network
                </Typography>
              </StyledGridItem>
            )}
          </Grid>
        )} */}

        <Grid container spacing={1} paddingTop="6px">
          {permissionNames.includes('User Management') && (
            <StyledGridItem
              item
              xs={6}
              sx={{
                cursor: 'pointer',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                padding: '8px',
              }}
              onClick={() => navigate('/userManagement')}
            >
              <Icon
                icon={SmallPopupIcons.management}
                style={{ fontSize: '28px' }} // Adjust size as needed
              />
              <Typography
                align="center"
                fontSize="10px"
                fontWeight={600}
                sx={{ wordWrap: 'break-word', width: '100%' }}
              >
                Access Control
              </Typography>
            </StyledGridItem>
          )}

          {permissionNames.includes('Partner Network') && (
            <StyledGridItem
              item
              xs={6}
              sx={{
                cursor: 'pointer',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                padding: '8px',
              }}
              onClick={() => navigate('/kmzMap')}
            >
              <Icon
                icon={SmallPopupIcons.otn}
                style={{ fontSize: '28px' }} // Adjust size as needed
              />
              <Typography
                align="center"
                color="rgba(0, 0, 0, 1)"
                fontSize="10px"
                fontWeight={600}
                sx={{ wordWrap: 'break-word', width: '100%' }}
              >
                Comprehensive Route Planning
              </Typography>
            </StyledGridItem>
          )}
        </Grid>

        <Typography
          variant="h6"
          gutterBottom
          sx={{ mt: 1.5, borderBottom: '1px solid #E4E4E7' }}
          fontSize={'11px'}
          fontWeight={600}
          color="rgba(0, 0, 0, 0.5)"
        >
          Network Monitoring
        </Typography>
        <Grid container spacing={1} paddingTop={'6px'}>
          {permissionNames.includes('FTTS') && (
            <StyledGridItem
              item
              xs={3}
              sx={{ cursor: 'pointer' }}
              onClick={() => {
                console.log('FTTS clicked from popup');
                handleTabSelection('ftts');
                // Force left bar to update by dispatching a custom event
                window.dispatchEvent(
                  new CustomEvent('tabSelectionChanged', {
                    detail: { tab: 'ftts', iconIndex: NavigationIcons.NETWORK_MONITORING },
                  })
                );
              }}
            >
              <Icon icon={SmallPopupIcons.ftts} />
              <Typography
                align="center"
                color="rgba(0, 0, 0, 1)"
                fontSize={'10px'}
                fontWeight={600}
              >
                FTTS
              </Typography>
            </StyledGridItem>
          )}
          {permissionNames.includes('MPBN') && (
            <StyledGridItem
              item
              xs={3}
              sx={{ cursor: 'pointer' }}
              onClick={() => {
                console.log('MPBN clicked from popup');
                handleTabSelection('mpbn');
                // Force left bar to update by dispatching a custom event
                window.dispatchEvent(
                  new CustomEvent('tabSelectionChanged', {
                    detail: { tab: 'mpbn', iconIndex: NavigationIcons.NETWORK_MONITORING },
                  })
                );
              }}
            >
              <Icon icon={SmallPopupIcons.mpbn} />
              <Typography
                align="center"
                color="rgba(0, 0, 0, 1)"
                fontSize={'10px'}
                fontWeight={600}
              >
                MPBN
              </Typography>
            </StyledGridItem>
          )}
          {permissionNames.includes('OTN') && (
            <StyledGridItem
              item
              xs={3}
              sx={{ cursor: 'pointer' }}
              onClick={() => {
                console.log('OTN clicked from popup');
                handleTabSelection('otn');
                // Force left bar to update by dispatching a custom event
                window.dispatchEvent(
                  new CustomEvent('tabSelectionChanged', {
                    detail: { tab: 'otn', iconIndex: NavigationIcons.NETWORK_MONITORING },
                  })
                );
              }}
            >
              <Icon icon={SmallPopupIcons.otn} />
              <Typography
                align="center"
                color="rgba(0, 0, 0, 1)"
                fontSize={'10px'}
                fontWeight={600}
              >
                OTN
              </Typography>
            </StyledGridItem>
          )}
          {permissionNames.includes('IPRAN') && (
            <StyledGridItem
              item
              xs={3}
              sx={{ cursor: 'pointer' }}
              onClick={() => {
                console.log('IPRAN clicked from popup');
                handleTabSelection('ipran');
                // Force left bar to update by dispatching a custom event
                window.dispatchEvent(
                  new CustomEvent('tabSelectionChanged', {
                    detail: { tab: 'ipran', iconIndex: NavigationIcons.NETWORK_MONITORING },
                  })
                );
              }}
            >
              <Icon icon={SmallPopupIcons.ipran} />
              <Typography
                align="center"
                color="rgba(0, 0, 0, 1)"
                fontSize={'10px'}
                fontWeight={600}
              >
                IPRAN
              </Typography>
            </StyledGridItem>
          )}
        </Grid>
        <Typography
          variant="h6"
          gutterBottom
          sx={{ mt: 1.5, borderBottom: '1px solid #E4E4E7' }}
          fontSize={'11px'}
          fontWeight={600}
          color="rgba(0, 0, 0, 0.5)"
        >
          Sign Out
        </Typography>
        <LogoutIcon
          sx={{
            marginBottom: '8px',
            color: '#BD1D23',
            marginTop: '8px',
            cursor: 'pointer',
            transition: 'all 0.2s ease-in-out',
            '&:hover': {
              transform: 'scale(1.1)',
              color: '#8B1519',
            },
          }}
          onClick={handleLogout}
        />
      </Box>
    </>
  );
};
